<template>
  <v-container class="roma-home">
  <!-- Mobile-->
    <div class="hidden-md-and-up">
      <v-row>
        <v-col cols="12" class="col-sm-6">
          <v-col align="center" v-show="loadWelcome" cols="12">
            <img src="@/assets/images/wellcome-poll.png" alt width="125" />
          </v-col>
          <div class="roma-home__container-title">
            <h1 class="roma-home__title" v-if="isCode" v-show="filter">
              Ingresa los datos para buscar la encuesta
            </h1>
            <h1 class="roma-home__title" v-else v-show="filter">
              Selecciona tu curso para buscar la encuesta
            </h1>
          </div>
          <v-col class="hidden-xs-only hidden-md-and-up">
            <RomaCardPoll v-if="isPoll" :polls="polls"></RomaCardPoll>
            <RomaNoAvailable
                    v-if="noAvailable"
                    :message="message"
                    :position="positionMessage"
            ></RomaNoAvailable>
            <v-col v-if="isLoading" align="center" class="waiting">
              <h1>Cargando información...</h1>
              <img src="@/assets/images/waiting-icon.png" alt />
            </v-col>
          </v-col>
          <RomaSurveyReady v-if="readySurvey" class="hidden-xs-only hidden-md-and-up" />
        </v-col>

        <v-col cols="12" class="col-sm-6">
          <v-row class="mt-1" no-gutters v-if="filter">
            <v-col cols="12"
                   sm="12"
                   class="pa-2"
                   v-if="isCode">
              <v-text-field
                      v-model="codeMedicion"
                      label="Código de encuesta"
                      outlined
                      rounded
                      dense
              ></v-text-field>
            </v-col>
            <v-col
                    cols="12"
                    sm="12"
                    class="pa-2"
                    v-bind:class="{ 'offset-md-2': !isCode }"
            >
              <v-select
                      :items="categories"
                      label="Nivel"
                      dense
                      outlined
                      rounded
                      v-model="category"
                      @change="setCourse"
                      :item-text="(item) => item.name"
                      :item-value="(item) => item.categoryId"
              ></v-select>
            </v-col>
            <v-col cols="12"
                   sm="12"
                   class="pa-2"
                   v-bind:class="{ 'pr-4': !isCode }">
              <v-select
                      :items="courses"
                      label="Curso"
                      v-model="idSeccionOrigen"
                      dense
                      outlined
                      rounded
                      :item-text="(item) => item.abbreviation"
                      :item-value="(item) => item.sectionId"
              ></v-select>
            </v-col>
            <v-col cols="12">
              <v-btn
                      class="text-capitalize btn-search"
                      color="white"
                      rounded
                      @click="search"
              >
                <v-icon left color="primary">icon-search</v-icon>
                <span>Buscar</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-col>

        <v-col class="d-flex d-sm-none">
          <RomaCardPoll v-if="isPoll" :polls="polls"></RomaCardPoll>
          <RomaNoAvailable
                  v-if="noAvailable"
                  :message="message"
                  :position="positionMessage"
          ></RomaNoAvailable>
          <v-col v-if="isLoading" align="center" class="waiting">
            <h1>Cargando información...</h1>
            <img src="@/assets/images/waiting-icon.png" alt />
          </v-col>
          <RomaSurveyReady v-if="readySurvey" class="d-flex d-sm-none" />
        </v-col>

      </v-row>
    </div>
  <!-- End Mobile-->


  <!-- Desktop -->
    <div class="hidden-sm-and-down">
      <h1 class="roma-home__title" v-if="isCode" v-show="filter">
        Ingresa los datos para buscar la encuesta
      </h1>
      <h1 class="roma-home__title" v-else v-show="filter">
        Selecciona tu curso para buscar la encuesta
      </h1>
      <v-row class="mt-8" no-gutters v-if="filter">
        <v-col cols="3" offset-lg="1" sm="3" class="pa-2 pr-4" v-if="isCode">
          <v-text-field
                  v-model="codeMedicion"
                  label="Código de encuesta"
                  outlined
                  rounded
                  dense
          ></v-text-field>
        </v-col>
        <v-col
                cols="3"
                sm="3"
                class="pa-2 pr-4"
                v-bind:class="{ 'offset-lg-2': !isCode }"
        >
          <v-select
                  :items="categories"
                  label="Nivel"
                  dense
                  outlined
                  rounded
                  v-model="category"
                  @change="setCourse"
                  :item-text="(item) => item.name"
                  :item-value="(item) => item.categoryId"
          ></v-select>
        </v-col>
        <v-col cols="3" sm="3" class="pa-2" v-bind:class="{ 'pr-4': !isCode }">
          <v-select
                  :items="courses"
                  label="Curso"
                  v-model="idSeccionOrigen"
                  dense
                  outlined
                  rounded
                  :item-text="(item) => item.abbreviation"
                  :item-value="(item) => item.sectionId"
          ></v-select>
        </v-col>
        <v-col cols="auto">
          <v-btn
                  class="text-capitalize btn-search"
                  color="white"
                  rounded
                  @click="search"
          >
            <v-icon left color="primary">icon-search</v-icon>
            <span>Buscar</span>
          </v-btn>
        </v-col>
      </v-row>
    </div>

    <v-row class="ma-8 hidden-sm-and-down">
      <v-col align="center" v-show="loadWelcome" cols="12" class="hidden-sm-and-down">
        <img src="@/assets/images/wellcome-poll.png" alt />
      </v-col>
      <v-col>
        <RomaCardPoll v-if="isPoll" :polls="polls"></RomaCardPoll>
        <RomaNoAvailable
          v-if="noAvailable"
          :message="message"
          :position="positionMessage"
        ></RomaNoAvailable>
        <v-col v-if="isLoading" align="center" class="waiting">
          <h1>Cargando información...</h1>
          <img src="@/assets/images/waiting-icon.png" alt />
        </v-col>
      </v-col>
    </v-row>
    <RomaSurveyReady v-if="readySurvey" class="hidden-sm-and-down" />
  </v-container>
</template>

<script>
import RomaCardPoll from "@/components/poll/RomaCardPoll";
import { mapGetters, mapActions } from "vuex";
import RomaNoAvailable from "@/components/commons/RomaNoAvailable";
import RomaSurveyReady from "@/components/poll/RomaSurveyReady";

export default {
  name: "RomaHome",
  components: {
    RomaCardPoll,
    RomaNoAvailable,
    RomaSurveyReady,
  },
  data() {
    return {
      courses: [],
      loadWelcome: true,
      isCode: false,
      isPoll: false,
      isLoading: false,
      idSeccionOrigen: null,
      idInstitucion: null,
      idMedicionAsignada: null,
      idMedicion: null,
      codeMedicion: null,
      category: "",
      polls: [],
      filter: false,
      searchURL: null,
      noAvailable: false,
      message: null,
      positionMessage: null,
      readySurvey: false,
    };
  },

  async mounted() {
      if( Object.keys(this.$route.query).length === 0  ) 
      {
        console.log("ROMA HOME ->");
        // check user if there is no query , this happend when the api redirect after login
        await this.checkUserSesion();
      }

      const i =
        typeof this.$route.query.i === "undefined" || this.$route.query.i === ""
          ? null
          : this.$route.query.i;
      const m =
        typeof this.$route.query.m === "undefined" || this.$route.query.m === ""
          ? null
          : this.$route.query.m;
      const ma =
        typeof this.$route.query.ma === "undefined" || this.$route.query.ma === ""
          ? null
          : this.$route.query.ma;

      if (m !== null && ma !== null) {
        this.idInstitucion = i;
        this.idMedicion = m;
        this.idMedicionAsignada = ma;
         this.search();
      } else if (m !== null) {
        this.idInstitucion = i;
        this.idMedicion = m;
        this.filter = true
      } else if (ma !== null) {
        this.idInstitucion = i;
        this.idMedicionAsignada = ma;
        this.search();
      } else {
        // if(this.getMa > 0) {
        //   this.$router.push({path: "/encuesta/_#"})
        // } else {
        //   this.search();
        // }

        // is called when the route has no parameters
        this.filter = false;
        this.isCode = false;
        this.search();
    
      }
    this.setEnablePdfPoll({ enablePollMobile: false });

  },
  computed: {
    ...mapGetters({
      categories: "getCategories",
      getSurveys: "getAnsweredSurveys",
      getMa: "getMA",
      getUserData: "getUserData",
      getMaUser: "getMaUser",
      getLogged:"getLogged"
      
    }),
  },
  methods: {
    ...mapActions({
      setInformation: "setInformation",
      searchPoll: "searchPoll",
      toastError: "toastError",
      setEnablePdfPoll: "setEnablePdfPoll",
      actionSetUser: "actionSetUser",
      setLogged:"setLogged",
      resetUser: "resetUser",
      resetAllPoll: "resetAllPoll",
    }),
    search() {
      if (this.filter) {
        if (this.isCode) {
          if (this.codeMedicion === null || this.idSeccionOrigen === null) {
            this.toastError({
              title: "Filtros requeridos",
              message:
                "Ingresar todos los filtros para realizar la busqueda de encuestas",
            });
          } else {
            this.searchFilter();
          }
        } else {
          if (this.idSeccionOrigen === null) {
            this.toastError({
              title: "Filtros requeridos",
              message:
                "Seleccionar un curso para realizar la busqueda de encuestas",
            });
          } else {
            this.searchFilter();
          }
        }
      } else {
        this.searchFilter();
      }
    },

    async searchFilter() {
      this.noAvailable = false;
      this.readySurvey = false;
      this.loadWelcome = false;
      this.isLoading = true;
      this.isPoll = false;

      if(this.getLogged){
        //LOGUOT
        if (this.$route.query.i != undefined && this.$route.query.m != undefined && this.$route.query.ma != undefined) {
          
          // console.log("this.$route.query.i",this.$route.query.i);
          // console.log("this.$route.query.i",this.$route.query.i != "");
          this.resetUser();
          this.resetAllPoll();
          // add a timer to wait 1 sec
          setTimeout(() => {
            //window.location.href = `${process.env.VUE_APP_ROMA_ENCUESTA_API_URL}/init?i=${this.$route.query.i}&ma=${this.$route.query.ma}`
            window.location.reload(true)
          }, 100);
        }
        this.searchURL = `{idIntitucion}/{idMedicionAsignada}?idIntitucion=${this.getUserData.institutionContext.institutionId}&idMedicionAsignada=${this.getUserData.idMedicionAsignada}`;
      }else if (this.filter) {
        if (this.idMedicion !== null && !this.isCode) {
          this.searchURL = `{intitucionId}?idMedicion=${this.idMedicion}&idSeccionOrigen=${this.idSeccionOrigen}&intitucionId=${this.idInstitucion}`;
        } else {
          this.searchURL = `{intitucionId}?codeMedicion=${this.codeMedicion.toUpperCase()}&idSeccionOrigen=${this.idSeccionOrigen}&intitucionId=${this.idInstitucion}`;
        }
      } else {
        this.searchURL = `{idIntitucion}/{idMedicionAsignada}?idIntitucion=${this.idInstitucion}&idMedicionAsignada=${this.idMedicionAsignada}`;
      }
      await this.searchPoll(this.searchURL).then((response) => {
        
        // clean all poll
        // console.log("reseet here");
        // this.resetAllPoll();


        this.isLoading = false;
        if (response.data !== null ) {
            // console.log("typeof response.data",typeof response.data);
            // console.log("response.data",response.data);
            this.compareSurveysPerfilAccesoAndUserLogged(response);
                

          } else {
            // console.log("datos incorrectos");
            this.noAvailable = true;
            this.positionMessage = "top";
            if (this.filter) {
              this.message = `<h1>Encuesta no disponible para los datos buscados.</h1><h1>Puede verificar los datos ingresados y volver a intentarlo.</h1>`;
            } else {
              this.message = `<h1>Encuesta no encontrada.</h1><h1>Verifique el link enviado o contáctese con soporte Roma: +56 9 3458 0660</h1>`;
            }
          }
      });
    },
    disableLoading() {
      this.isLoading = false;
      this.isPoll = true;
    },
    getSurvey(survey) {
      const surveys = this.getSurveys.find((surv) => surv === survey);
      console.log("surveys",surveys);
      console.log("survey",survey);

      if (surveys === "undefined") {
        return false;
      } else {
        if (surveys !== "undefined") {
          return survey === surveys;
        }
      }
    },
    setCourse() {
      this.idSeccionOrigen = null;
      const response = this.categories.find(
        (categ) => categ.categoryId === this.category
      );
      this.courses = response.sections;
    },


    async checkUserSesion(){
      await this.actionSetUser().then(data => {
        if (data && data.data && data.data.personId != null) {  
            // console.log(data.data);
            this.setLogged(true);
        } else {
            // this.loadEvaluation();
            // this.$router.push({name: 'not-found'});
            // this.message = `<h1>No se encuentra evaluación válida para el usuario.</h1><h2>Contáctese con soporte Roma: +56 9 3458 0660</h2>`;
            // this.noAvailable = true;
            // console.log(this.$router.push({name: 'not-found'}));
            // console.log(this.$router.push);
            this.setLogged(false);
            this.noAvailable = true;
            this.positionMessage = "top";
            this.message = `<h1>No se pudo obtener al usuario.</h1><h1>Puede verificar los datos ingresados y volver a intentarlo.</h1>`;
        }
        return this.getLogged;
      });
    },
    compareSurveysPerfilAccesoAndUserLogged(response){

            // check if user is loged and has respective role 
            // and logout USER  if not
              // "Profesor"
              // "Alumno"
              // "Apoderado"

            // check if user is anonimous and logout USER  if not and redirect to 404
            // if(this.getLogged && response.data.perfil == 0 ){
            //   this.resetUser();
            //   this.$router.push({name: 'not-found'});
            // }
              
            // check if survey is with login 
            if(response && response.data && (response.data.perfil == 1 || response.data.perfil == 2 || response.data.perfil == 3)) {
              console.log("do nothing");

              if(this.getLogged ){
                console.log("do nothing");
                
                // check if user is loged and has respective (role and survey) if not logout USER and redirect to login
                if ( ((response.data.perfil == 1 || response.data.perfil == 3 ) && !this.getUserData.roles.includes("Alumno"))
                   || (response.data.perfil == 2  && !this.getUserData.roles.includes("Profesor"))
                   ||  response.data.seccionOrigen && response.data.idSeccionOrigen != this.getUserData.idSeccion && this.getUserData.roles.includes("Alumno")) 
                   {
                    console.log("encuesta no es de este usuario,entraste a una prueba que no es de tu rol");
                    this.noAvailable = true;
                    this.positionMessage = "top";
                    this.message = `<h1>Encuesta no disponible para tu usuario.</h1><h1>Puede verificar los datos ingresados, cerrar sesion y volver a intentarlo.</h1>`;
                  // no se encontro escuestro dicha encuesta para este usuario por favor verifique la url y vuelva a intentarlo cerrando sesion
                  // this.resetUser();
                  // window.location.href = `${process.env.VUE_APP_ROMA_ENCUESTA_API_URL}/init?i=${this.$route.query.i}&ma=${this.$route.query.ma}`
                }else{

                  //check if user has taken this survey
                  if(this.getUserData.hasTakenSurvey){
                    // show message that the survey has been taken
                    console.log("show message that the survey has been taken");
                    this.readySurvey = true; // taken survey message
                  }else{
                    this.readySurvey = false;
                    this.checkAndShowSurvey(response);
                  }
                }

              }else{
                window.location.href = `${process.env.VUE_APP_ROMA_ENCUESTA_API_URL}/init?i=${this.$route.query.i}&ma=${this.$route.query.ma}`
              }
            }

            // the survey is anonimous 
            if (response && response.data && (response.data.perfil == 0 || response.data.perfil == null )  ) {
              if (this.getLogged) {
                this.resetUser();
                window.location.reload(true)
                //window.location.href = `${process.env.VUE_APP_ROMA_LOGOUT_CAS}`
              }else{
               console.log("do nothing");
               this.checkAndShowSurvey(response);
              }
            } 

    },
    checkAndShowSurvey(response){
            const mda =
              typeof response.data === "undefined"
                ? null
                : response.data.idMedicionAsignada;
            if (mda !== null) {
              const survey = this.getSurvey(`${mda}`);
              if (survey) {
                // console.log("survey",survey);
                this.readySurvey = true;
              } else {
                this.polls = response.data;
                this.isPoll = true;
              }
            } else {
              this.noAvailable = true;
              this.positionMessage = "top";
              if (this.filter) {
                this.message = `<h1>Encuesta no disponible para los datos buscados.</h1><h1>Puede verificar los datos ingresados y volver a intentarlo.</h1>`;
              } else {
                this.message = `<h1>Encuesta no encontrada.</h1><h1>Verifique el link enviado o contáctese con soporte Roma: +56 9 3458 0660</h1>`;
              }
            }
    }
  }
};
</script>

<style lang="scss">
@import "../../assets/styles/roma-theme/partials/_colors";
.v-input input {
  text-transform: uppercase !important;
}
.roma-home {
  &__title {
    font-size: 36px;
    margin-top: 15px;
    text-align: center;
    font: Regular 36px/48px "Cabin", Regular, serif;
    color: map-get($colors, "primary");
  }
  .btn-search {
    width: 180px;
    height: 50px !important;
    background: #ffffff;
    box-shadow: 0 3px 6px #00000029 !important;
    border-radius: 50px;
    opacity: 1;
    span {
      color: #590564;
      font: Medium 20px/24px Cabin, Medium, serif;
      font-size: 18px;
      padding: 4px 8px 7px 8px;
    }
  }
  .icon-search:before {
    content: url("../../assets/images/search-icon.svg");
  }
  .waiting {
    h1 {
      font-family: "Cabin", Regular, serif;
      font-weight: normal;
      font-size: 27px;
      margin-bottom: 50px;
      margin-top: 30px;
    }
  }
}
@media (max-width: 800px) {
.roma-home {
    .btn-search {
      max-width: 100%;
      width: 95%;
      margin: 8px 2px 0 10px;
    }
      &__title {
        font-size: 20px;
        margin-top: 1px;
        text-align: center;
        font: Regular 16px/22px "Cabin", Regular, serif;
        color: map-get($colors, "primary");
      }
    &__container-title {
      margin-left: 15%;
      width: 70%;
      }
    }
  .waiting {
    margin-top: 0 !important;
    h1 {
      font-size: 18px !important;
      margin-bottom: 10px !important;
      margin-top: 10px !important;
    }
  }
  }

</style>
